import React, { useState, useEffect } from 'react';
import { ChevronLeft, Headphones, Music, Check } from 'lucide-react';

import startPay from "../../utlis/paymentUlti";

import { PiWarningCircleFill } from "react-icons/pi";

import { Typography, Button } from "@mui/material";


import axios from "axios";
import { getHeaders } from "../../utlis/security";
import useModal from '../../hooks/useModel';
import { FaCheckCircle } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";

const PaymentScreen = () => {
  const [currentView, setCurrentView] = useState('payment'); // 'payment' or 'package'
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState('');
  const [selectedAmount, setSelectedAmount] = useState('');
  const [paymentImage, setPaymentImage] = useState('');
  const [paymentText, setPaymentText] = useState('');
  const [loading, setLoading] = useState(true);
  const [packageLoading, setPackageLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const [modalActions, setModalActions] = useState(null);
  const [modalBody, setModalBody] = useState(null);
   const navigate = useNavigate();

  const [Modal, openModal, closeModal] = useModal();

  useEffect(() => {
    fetchPaymentMethods();
  }, []);

  const handleSuccessBtn = () => {
    closeModal();
    setModalActions(null);
    setModalBody(null);
    navigate("/");
  };

  const handleFailBtn = () => {
    closeModal();
    setModalActions(null);
    setModalBody(null);
    navigate("/account/purchase_subscription");
  };

  const fetchPaymentMethods = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://snsapiv2.baganit.com/api/payment/listv2', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          type: "purchased"
        }),
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch payment methods');
      }
      
      const result = await response.json();
      
      if (result.status === 1) {
        setPaymentMethods(result.data || []);
        setPaymentImage(result.payment_image || '');
        setPaymentText(result.payment_text || '');
      } else {
        throw new Error(result.message || 'Failed to load payment methods');
      }
    } catch (err) {
      setError(err.message);
      console.error('Error fetching payment methods:', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchPackages = async () => {
    try {
      setPackageLoading(true);
      const response = await fetch('https://snsapiv2.baganit.com/api/payment/package/listv2', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          type: "purchased"
        }),
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch packages');
      }
      
      const result = await response.json();
      
      if (result.status === 1) {
        setPackages(result.package || []);
        setPaymentImage(result.payment_image || '');
        setPaymentText(result.payment_text || '');
      } else {
        throw new Error(result.message || 'Failed to load packages');
      }
    } catch (err) {
      setError(err.message);
      console.error('Error fetching packages:', err);
    } finally {
      setPackageLoading(false);
    }
  };

  const handleBackPress = () => {
    if (currentView === 'package') {
      setCurrentView('payment');
      setSelectedPackage('');
    } else {
      // Handle back navigation to previous screen
      console.log('Back pressed');
    }
  };

  const handlePaymentSelect = async (paymentMethod) => {
    setSelectedPaymentMethod(paymentMethod);
    setCurrentView('package');
    await fetchPackages();
  };

  const handlePackageSelect = (packageId, amount) => {
    setSelectedPackage(packageId);
    setSelectedAmount(amount);
  };

  const handleSubmit = async () => {
    console.log("selected package ", selectedPackage);
    setIsButtonLoading(true);
      if (selectedPackage) {
        const payload = {
          payment_id: selectedPackage,
          payment_name: "KBZPAYMINI",  //KBZPAYMINI
          amount: selectedAmount,
          phone: "", 
          platform: "miniapp",
          udid: "190740e5f0032702",
          user_id:  JSON.parse(localStorage.getItem("userId")), // "959770179977", //JSON.parse(localStorage.getItem("userId")), //JSON.parse(localStorage.getItem("userId")), 
          version_code: 29,  // this is for development
          // version_code: 1001, // this is for production
          version_name: "1.2.9",
        };

        console.log("payload", payload);


        const headers = await getHeaders('purchase_subscription');

        axios
        .post(
          "https://apiv2.shwenarsin.com/api/payment/buy/miniapp/package",
          payload,
          {headers}
        )
        .then((response) => {

        console.log(response);
        console.log("message ", response);
        
        // Handle the response if needed
        if (response.data.message == "Success") {
          console.log("ready to start pay");
          console.log( response.data.prepay_id);
          console.log("order_info", response.data.orderInfo);
          startPay(
            response.data.prepay_id,
            response.data.orderInfo,
            response.data.sign,
            (res) => {
              console.log('startPay', res);
              if (res.resultCode == 1) {
                setModalBody(
                  <div className="text-center">
                     <div className="">
                    <FaCheckCircle color="#008000" size={40} className="inline-block" />
                    </div>
                    <div className="mt-4">
                    <Typography
                      variant="body1"
                      component="div"
                      lineHeight={2}
                      fontWeight="bold"
                    >
                      ငွေပေးချေမှုအောင်မြင်ပါသည်
                    </Typography>
                    </div>
                  </div>
                );

                setModalActions(
                  <div className="flex items-center justify-center ml-10 mr-10 mb-5">
                    <Button
                      size="small"
                      variant="contained"
                      disableRippl
                      onClick={() => {
                        handleSuccessBtn();
                      }}
                      sx={{
                        marginTop: "20px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        paddingRight: "50px",
                        paddingLeft: "50px",
                        borderTopLeftRadius: "10px",
                        borderBottomLeftRadius: "10px",
                        borderTopRightRadius: "10px",
                        borderBottomRightRadius: "10px",
                        backgroundColor: "#facc15",
                        color: "black",
                        fontWeight: "600",
                        "&:hover": {
                          backgroundColor: "#eab308",
                          borderColor: "#eab308",
                          boxShadow: "none",
                        },
                        "&:active": {
                          boxShadow: "none",
                          backgroundColor: "#facc15",
                          borderColor: "#ca8a04",
                        },
                      }}
                    >
                      အခုပဲနားထောင်မည်
                    </Button>
                  </div>
                );
              } else {
                setModalBody(
                  <div className="text-center">
                    <div className="">
                    <PiWarningCircleFill color="#FF0000" size={40} className="inline-block" />
                    </div>
                   <div className="mt-4">
                    <Typography
                        variant="body1"
                        component="span"
                        lineHeight={1}
                        fontWeight="bold"
                        className="block"
                      >
                        ငွေပေးချေမှုမအောင်မြင်ပါ
                      </Typography>
                   </div>
                  </div>
                );
      
                setModalActions(
                  <div className="flex items-center justify-center ml-10 mr-10 mb-5">
                    <Button
                      size="small"
                      variant="contained"
                      disableRippl
                      onClick={() => {
                        handleFailBtn();
                      }}
                      sx={{
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        paddingRight: "60px",
                        paddingLeft: "60px",
                        borderTopLeftRadius: "10px",
                        borderBottomLeftRadius: "10px",
                        borderTopRightRadius: "10px",
                        borderBottomRightRadius: "10px",
                        backgroundColor: "#facc15",
                        color: "black",
                        fontWeight: "600",
                        "&:hover": {
                          backgroundColor: "#eab308",
                          borderColor: "#eab308",
                          boxShadow: "none",
                        },
                        "&:active": {
                          boxShadow: "none",
                          backgroundColor: "#facc15",
                          borderColor: "#ca8a04",
                        },
                      }}
                    >
                      ထပ်ဝယ်ယူမည်
                    </Button>
                  </div>
                );
              }
              openModal();
              setIsButtonLoading(false); // Reset loading state after modal is opened
            }
          );
        } else {
          setIsButtonLoading(false);
        }
      });
      }
  };

  const Header = () => (
    <div className="flex items-center px-4 py-4 bg-white border-b border-gray-100">
      <button onClick={handleBackPress} className="mr-4">
        <ChevronLeft size={24} className="text-gray-700" />
      </button>
      <h1 className="text-lg font-medium text-gray-900">Payment</h1>
    </div>
  );

  const PaymentOption = ({ method }) => (
    <div 
      className="flex items-center px-4 py-4 bg-white border-b border-gray-100 cursor-pointer hover:bg-gray-50 transition-colors"
      onClick={() => handlePaymentSelect(method)}
    >
      <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mr-4">
        {method.image ? (
          <img 
            src={method.image} 
            alt={method.name}
            className="w-8 h-8 object-contain"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
        ) : null}
        <div className="text-white font-bold text-sm" style={{display: method.image ? 'none' : 'block'}}>
          {method.name?.substring(0, 3) || 'KBZ'}
        </div>
      </div>
      <div className="flex-1">
        <h3 className="text-base font-medium text-gray-900">{method.description || method.name}</h3>
      </div>
    </div>
  );

  const PackageOption = ({ pkg }) => (
    <div 
      className="flex items-center px-6 py-4 cursor-pointer hover:bg-gray-50 transition-colors"
      onClick={() => handlePackageSelect(pkg.package_id, pkg.amount)}
    >
      <div className="mr-4">
        <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
          selectedPackage === pkg.package_id 
            ? 'border-blue-500 bg-blue-500' 
            : 'border-gray-400 bg-white'
        }`}>
          {selectedPackage === pkg.package_id && (
            <div className="w-2 h-2 bg-white rounded-full"></div>
          )}
        </div>
      </div>
      <div className="flex-1">
        <h3 className="text-sm text-gray-700">{pkg.description}</h3>
      </div>
    </div>
  );

  if (currentView === 'payment') {
    if (loading) {
      return (
        <div className="min-h-screen bg-gray-50">
          <Header />
          <div className="flex items-center justify-center py-20">
            <div className="text-gray-500">Loading payment methods...</div>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="min-h-screen bg-gray-50">
          <Header />
          <div className="flex flex-col items-center justify-center py-20 px-4">
            <div className="text-red-500 text-center mb-4">Error: {error}</div>
            <button 
              onClick={fetchPaymentMethods}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Retry
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        
        <div className="bg-white mb-20">
          {paymentMethods.length > 0 ? (
            paymentMethods
              .filter(method => method.status)
              .map((method, index) => (
                <PaymentOption key={method.payment_id || index} method={method} />
              ))
          ) : (
            <div className="flex items-center justify-center py-20">
              <div className="text-gray-500">No payment methods available</div>
            </div>
          )}
        </div>
      </div>
    );
  }

  // Package selection view
  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-600 via-yellow-500 to-orange-600 relative">
      {/* Background image with books */}
      {paymentImage && (
        <div className="">
          <img 
            src={paymentImage} 
            alt="Background" 
            className="w-full h-full"
          />
        </div>
      )}

      {/* Package selection area */}
      <div className="relative z-10 bg-gray-50 flex-1 min-h-96">
        <div className="px-6 py-8">
          {paymentText && (
            <div className="text-center mb-8">
              <p className="text-gray-700 text-xs font-bold leading-relaxed">
                {paymentText}
              </p>
            </div>
          )}

          {packageLoading ? (
            <div className="flex items-center justify-center py-12">
              <div className="text-gray-500">Loading packages...</div>
            </div>
          ) : (
            <div className="space-y-2">
              {packages.map((pkg, index) => (
                <PackageOption key={pkg.package_id || index} pkg={pkg} />
              ))}
            </div>
          )}

          {/* Submit button */}
          <div className="mt-12 mb-20">
            <button 
              onClick={handleSubmit}
              disabled={!selectedPackage || packageLoading || isButtonLoading}
              className={`w-full py-3 rounded-full text-lg font-semibold transition-colors flex items-center justify-center ${
                selectedPackage && !packageLoading && !isButtonLoading
                  ? 'bg-yellow-500 text-white hover:bg-yellow-600'
                  : 'bg-gray-400 text-gray-600 cursor-not-allowed'
              }`}
            >
              {isButtonLoading ? (
                <>
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                  Processing...
                </>
              ) : (
                'Submit'
              )}
            </button>
          </div>
        </div>
      </div>

      <Modal
        title=""
        body={modalBody}
        actions={modalActions}
      />
    </div>
  );
};

export default PaymentScreen;